import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../../const/AppRoutesName';
import { CanDeactivateGuard } from '../../../gards/can-deactivate-guard.service';

export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.FR.EMPLOYEES,
    loadComponent: () =>
      import('./crud-employees.component').then(
        (m) => m.CrudEmployeesComponent,
      ),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.EMPLOYEES + '/:slug' + '/:id',
    loadComponent: () =>
      import('../crud-employee/crud-employee.component').then(
        (m) => m.CrudEmployeeComponent,
      ),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.EMPLOYEES,
    loadComponent: () =>
      import('./crud-employees.component').then(
        (m) => m.CrudEmployeesComponent,
      ),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.EMPLOYEES + '/:slug' + '/:id',
    loadComponent: () =>
      import('../crud-employee/crud-employee.component').then(
        (m) => m.CrudEmployeeComponent,
      ),
    canDeactivate: [CanDeactivateGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CrudEmployeesModule {}
